import { ButtonHeading } from "components";
import useDocumentTitle from "hooks/useDocumentTitle";
import { QuickUploadModal } from "modals";
import React, { useState } from "react";
import { LiaTruckSolid } from "react-icons/lia";
import { useNavigate } from "react-router-dom";
import './quickUpload.css'

const QuickUpload = () => {
  useDocumentTitle("Quick Upload | T360");
  const navigate = useNavigate();
  const [quickUploadOpen, setQuickUploadOpen] = useState({
    open: false,
    title: "",
  });

  const quickProps = {
    isOpen: quickUploadOpen?.open,
    title: quickUploadOpen?.title,
    closeModal: (e) =>
      setQuickUploadOpen({
        ...quickUploadOpen,
        open: false,
      }),
    headerPart: false,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Quick Upload",
    submitTitle: "Upload",
    cancelButtonTitle: "cancel",
  };

  const accordionData = [
    {
      id: 1,
      title: "Quick Upload",
      show: true,
    },
    {
      id: 2,
      title: "Lr Upload",
      show: false,
    },
    {
      id: 3,
      title: "Contract Rates Upload",
      show: false,
    },
  ];

  return (
    <>
      <ButtonHeading
        title="Quick Upload"
      // onClick={{}} buttonTitle="Reports Sharing"
      />

      <div>
        <div className="accordion" id="quickUploadAccordion">
          <div className="accordion-item" >
            <h2 className="accordion-header" id="headingOne">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                {accordionData[0].title}
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              aria-labelledby="headingOne"
              data-bs-parent="#quickUploadAccordion"

            >
              <div className="accordion-body">
                <div className="row">

                  <div className="col-12 ">
                    <div className="__qwkMain_bx">
                      <div
                        className="_quickCards"
                        onClick={() => navigate("/quick_uploads/parle_bill")}
                      >
                        <div className="_quickCards_body">
                          <div className="text-center">
                            <p className="_fasTruck">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M18 4V0M7 18H5M19 18H9M7 14H5M19 14H9M6 4V0M1 9H23M1 23H23V4H1V23Z"
                                  stroke="#000D24"
                                  strokeWidth="2"
                                />
                              </svg>
                            </p>
                            <small className="hash-text">#43534</small>
                            <p className="__qwText">Plan Upload</p>
                          </div>
                        </div>
                      </div>

                      <div
                        className="_quickCards"
                        onClick={() => navigate("/quick_uploads/party_address")}
                      >
                        <div className="_quickCards_body">
                          <div className="text-center">
                            <p className="_fasTruck">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="28"
                                height="28"
                                viewBox="0 0 28 28"
                                fill="none"
                              >
                                <path
                                  d="M14.0001 4.66669C15.2378 4.66669 16.4247 5.15835 17.2999 6.03352C18.1751 6.90869 18.6667 8.09568 18.6667 9.33335C18.6667 10.571 18.1751 11.758 17.2999 12.6332C16.4247 13.5084 15.2378 14 14.0001 14C12.7624 14 11.5754 13.5084 10.7002 12.6332C9.82508 11.758 9.33341 10.571 9.33341 9.33335C9.33341 8.09568 9.82508 6.90869 10.7002 6.03352C11.5754 5.15835 12.7624 4.66669 14.0001 4.66669ZM14.0001 7.00002C13.3812 7.00002 12.7878 7.24585 12.3502 7.68344C11.9126 8.12102 11.6667 8.71452 11.6667 9.33335C11.6667 9.95219 11.9126 10.5457 12.3502 10.9833C12.7878 11.4209 13.3812 11.6667 14.0001 11.6667C14.6189 11.6667 15.2124 11.4209 15.65 10.9833C16.0876 10.5457 16.3334 9.95219 16.3334 9.33335C16.3334 8.71452 16.0876 8.12102 15.65 7.68344C15.2124 7.24585 14.6189 7.00002 14.0001 7.00002ZM14.0001 15.1667C17.1151 15.1667 23.3334 16.7184 23.3334 19.8334V23.3334H4.66675V19.8334C4.66675 16.7184 10.8851 15.1667 14.0001 15.1667ZM14.0001 17.3834C10.5351 17.3834 6.88341 19.0867 6.88341 19.8334V21.1167H21.1167V19.8334C21.1167 19.0867 17.4651 17.3834 14.0001 17.3834Z"
                                  fill="black"
                                />
                              </svg>
                            </p>
                            <small className="hash-text">#43534</small>
                            <p className="__qwText">Party Address</p>
                          </div>
                        </div>
                      </div>

                      <div
                        className="_quickCards"
                        onClick={() => navigate("/quick_uploads/fuel_card")}
                      >
                        <div className="_quickCards_body">
                          <div className="text-center">
                            <p className="_fasTruck">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="22"
                                viewBox="0 0 22 22"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_11508_2234)">
                                  <path
                                    d="M5.16675 4.01845C5.16675 3.97916 5.18236 3.94148 5.21014 3.91369C5.23792 3.88591 5.27561 3.8703 5.3149 3.8703H11.7964C11.8357 3.8703 11.8734 3.88591 11.9011 3.91369C11.9289 3.94147 11.9445 3.97916 11.9445 4.01845V10.4999C11.9445 10.5392 11.9289 10.5769 11.9011 10.6047C11.8734 10.6325 11.8357 10.6481 11.7964 10.6481H5.3149C5.27561 10.6481 5.23792 10.6325 5.21014 10.6047C5.18236 10.5769 5.16675 10.5392 5.16675 10.4999V4.01845Z"
                                    stroke="black"
                                  />
                                  <path
                                    d="M2.07413 3.37036C2.07413 2.68277 2.34728 2.02333 2.83348 1.53712C3.31969 1.05092 3.97912 0.777771 4.66672 0.777771L12.4445 0.777771C13.1321 0.777771 13.7915 1.05092 14.2777 1.53712C14.7639 2.02333 15.0371 2.68277 15.0371 3.37036V13.7407C15.7247 13.7407 16.3841 14.0139 16.8703 14.5001C17.3565 14.9863 17.6297 15.6457 17.6297 16.3333V16.9815C17.6297 17.1534 17.698 17.3182 17.8195 17.4398C17.9411 17.5613 18.1059 17.6296 18.2778 17.6296C18.4497 17.6296 18.6146 17.5613 18.7361 17.4398C18.8577 17.3182 18.926 17.1534 18.926 16.9815V11.1481H18.2778C18.1059 11.1481 17.9411 11.0799 17.8195 10.9583C17.698 10.8368 17.6297 10.6719 17.6297 10.5V6.44907C17.6297 6.27717 17.698 6.11231 17.8195 5.99076C17.9411 5.86921 18.1059 5.80092 18.2778 5.80092H20.2158C20.2015 5.18388 20.1471 4.64203 19.9552 4.21685C19.8525 3.96962 19.6736 3.76163 19.4445 3.62314C19.206 3.48055 18.843 3.37036 18.2778 3.37036C18.1059 3.37036 17.9411 3.30208 17.8195 3.18053C17.698 3.05897 17.6297 2.89411 17.6297 2.72222C17.6297 2.55032 17.698 2.38546 17.8195 2.26391C17.9411 2.14235 18.1059 2.07407 18.2778 2.07407C19.0089 2.07234 19.6191 2.21752 20.1082 2.50962C20.6047 2.80518 20.9301 3.22388 21.1375 3.68536C21.5199 4.53444 21.5186 5.58444 21.5186 6.38296V10.4987C21.5187 10.5839 21.5021 10.6683 21.4696 10.7471C21.4371 10.8259 21.3894 10.8975 21.3292 10.9578C21.269 11.0182 21.1975 11.066 21.1188 11.0987C21.04 11.1313 20.9557 11.1481 20.8704 11.1481H20.2223V16.9815C20.2223 17.4972 20.0174 17.9918 19.6528 18.3564C19.2881 18.7211 18.7935 18.9259 18.2778 18.9259C17.7621 18.9259 17.2676 18.7211 16.9029 18.3564C16.5382 17.9918 16.3334 17.4972 16.3334 16.9815V16.3333C16.3334 15.9895 16.1968 15.6598 15.9537 15.4167C15.7106 15.1736 15.3809 15.037 15.0371 15.037V20.2222H15.6852C15.8571 20.2222 16.022 20.2905 16.1436 20.4121C16.2651 20.5336 16.3334 20.6985 16.3334 20.8704C16.3334 21.0423 16.2651 21.2071 16.1436 21.3287C16.022 21.4502 15.8571 21.5185 15.6852 21.5185H1.42598C1.25408 21.5185 1.08922 21.4502 0.96767 21.3287C0.846119 21.2071 0.777832 21.0423 0.777832 20.8704C0.777832 20.6985 0.846119 20.5336 0.96767 20.4121C1.08922 20.2905 1.25408 20.2222 1.42598 20.2222H2.07413V3.37036ZM13.7408 3.37036C13.7408 3.02656 13.6042 2.69685 13.3611 2.45374C13.118 2.21064 12.7883 2.07407 12.4445 2.07407H4.66672C4.32292 2.07407 3.9932 2.21064 3.7501 2.45374C3.507 2.69685 3.37042 3.02656 3.37042 3.37036V20.2222H13.7408V3.37036Z"
                                    fill="black"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_11508_2234">
                                    <rect
                                      width="20.7407"
                                      height="20.7407"
                                      fill="white"
                                      transform="translate(0.777832 0.777771)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                            </p>
                            <small className="hash-text">#43534</small>
                            <p className="__qwText">Fuel Card Upload</p>
                          </div>
                        </div>
                      </div>

                      <div
                        className="_quickCards"
                        onClick={() => navigate("/quick_uploads/fastag")}
                      >
                        <div className="_quickCards_body">
                          <div className="text-center">
                            <p className="_fasTruck">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M12.4302 4.0625H17.5702C19.8677 4.0625 21.6877 4.0625 23.1115 4.25375C24.5765 4.45125 25.7627 4.86625 26.699 5.80125C27.634 6.7375 28.049 7.92375 28.2465 9.38875C28.359 10.23 28.4052 11.2087 28.424 12.3425C28.4395 12.4376 28.4412 12.5344 28.429 12.63C28.4365 13.3367 28.4394 14.1033 28.4377 14.93V15.07C28.4377 17.3675 28.4377 19.1875 28.2465 20.6112C28.049 22.0763 27.634 23.2625 26.699 24.1987C25.7627 25.1337 24.5765 25.5487 23.1115 25.7463C21.6865 25.9375 19.8677 25.9375 17.5702 25.9375H12.4302C10.1327 25.9375 8.31271 25.9375 6.88896 25.7463C5.42396 25.5487 4.23771 25.1337 3.30146 24.1987C2.36646 23.2625 1.95146 22.0763 1.75396 20.6112C1.56271 19.1863 1.56271 17.3675 1.56271 15.07V14.93C1.56104 14.1033 1.56396 13.3367 1.57146 12.63C1.55885 12.5345 1.56012 12.4377 1.57521 12.3425C1.59521 11.2087 1.64146 10.23 1.75396 9.38875C1.95146 7.92375 2.36646 6.7375 3.30146 5.80125C4.23771 4.86625 5.42396 4.45125 6.88896 4.25375C8.31396 4.0625 10.1327 4.0625 12.4302 4.0625ZM3.44021 13.4375C3.43854 13.9225 3.43771 14.4433 3.43771 15C3.43771 17.3837 3.44021 19.0775 3.61271 20.3625C3.78146 21.6188 4.09896 22.3438 4.62771 22.8725C5.15646 23.4013 5.88146 23.7188 7.13896 23.8875C8.42396 24.06 10.1165 24.0625 12.5002 24.0625H17.5002C19.884 24.0625 21.5777 24.06 22.8627 23.8875C24.119 23.7188 24.844 23.4013 25.3727 22.8725C25.9015 22.3438 26.219 21.6187 26.3877 20.3612C26.5602 19.0762 26.5627 17.3837 26.5627 15C26.5627 14.4433 26.5619 13.9225 26.5602 13.4375H3.44021ZM26.5302 11.5625H3.47021C3.49521 10.8288 3.53771 10.195 3.61271 9.6375C3.78146 8.38125 4.09896 7.65625 4.62771 7.1275C5.15646 6.59875 5.88146 6.28125 7.13896 6.1125C8.42396 5.94 10.1165 5.9375 12.5002 5.9375H17.5002C19.884 5.9375 21.5777 5.94 22.8627 6.1125C24.119 6.28125 24.844 6.59875 25.3727 7.1275C25.9015 7.65625 26.219 8.38125 26.3877 9.63875C26.4627 10.195 26.5052 10.8288 26.5302 11.5625ZM6.56271 20C6.56271 19.7514 6.66148 19.5129 6.8373 19.3371C7.01311 19.1613 7.25157 19.0625 7.50021 19.0625H12.5002C12.7489 19.0625 12.9873 19.1613 13.1631 19.3371C13.3389 19.5129 13.4377 19.7514 13.4377 20C13.4377 20.2486 13.3389 20.4871 13.1631 20.6629C12.9873 20.8387 12.7489 20.9375 12.5002 20.9375H7.50021C7.25157 20.9375 7.01311 20.8387 6.8373 20.6629C6.66148 20.4871 6.56271 20.2486 6.56271 20ZM14.6877 20C14.6877 19.7514 14.7865 19.5129 14.9623 19.3371C15.1381 19.1613 15.3766 19.0625 15.6252 19.0625H17.5002C17.7488 19.0625 17.9873 19.1613 18.1631 19.3371C18.3389 19.5129 18.4377 19.7514 18.4377 20C18.4377 20.2486 18.3389 20.4871 18.1631 20.6629C17.9873 20.8387 17.7488 20.9375 17.5002 20.9375H15.6252C15.3766 20.9375 15.1381 20.8387 14.9623 20.6629C14.7865 20.4871 14.6877 20.2486 14.6877 20Z"
                                  fill="black"
                                />
                              </svg>
                            </p>
                            <small className="hash-text">#43534</small>
                            <p className="__qwText">Fastag Upload</p>
                          </div>
                        </div>
                      </div>

                      <div
                        className="_quickCards"
                        onClick={() =>
                          navigate("/quick_uploads/contract_rates_uplaod")
                        }
                      >
                        <div className="_quickCards_body">
                          <div className="text-center">
                            <p className="_fasTruck">
                              <svg
                                viewBox="0 0 1024 1024"
                                className="icon"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="#000000"
                                width="30"
                                height="30"
                              >
                                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                <g
                                  id="SVGRepo_tracerCarrier"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></g>
                                <g id="SVGRepo_iconCarrier">
                                  <path
                                    d="M146.3 73.06v877.71h512l219.43-239.38V73.06H146.3z m512.01 769.46V694.77h135.44L658.31 842.52z m146.27-220.89H585.16v256H219.44V146.2h585.14v475.43z"
                                    fill="#0F1F3C"
                                  ></path>
                                  <path
                                    d="M292.59 219.34h438.86v73.14H292.59zM292.59 365.63H658.3v73.14H292.59zM292.59 511.91h219.43v73.14H292.59z"
                                    fill="#0F1F3C"
                                  ></path>
                                </g>
                              </svg>
                            </p>
                            <small className="hash-text">#43534</small>
                            <p className="__qwText">Contract Rates Upload</p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="_quickCards"
                        onClick={() => navigate("/quick_uploads/lr_uplaod_option")}
                      >
                        <div className="_quickCards_body">
                          <div className="text-center">
                            <p className="_fasTruck">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="40px"
                                height="40px"
                                viewBox="0 0 512 512"
                                version="1.1"
                              >
                                <title>details</title>
                                <g
                                  id="Page-1"
                                  stroke="none"
                                  strokeWidth="1"
                                  fill="none"
                                  fillRule="evenodd"
                                >
                                  <g
                                    id="Combined-Shape"
                                    fill="#000000"
                                    transform="translate(64.000000, 64.000000)"
                                  >
                                    <path d="M384,64 L384,384 L64,384 L64,64 L384,64 Z M341.333333,106.666667 L106.666667,106.666667 L106.666667,341.333333 L341.333333,341.333333 L341.333333,106.666667 Z M320,1.42108547e-14 L320,42.6666667 L42.666,42.666 L42.6666667,320 L1.42108547e-14,320 L1.42108547e-14,1.42108547e-14 L320,1.42108547e-14 Z M298.666667,234.666667 L298.666667,277.333333 L149.333333,277.333333 L149.333333,234.666667 L298.666667,234.666667 Z M298.666667,149.333333 L298.666667,192 L149.333333,192 L149.333333,149.333333 L298.666667,149.333333 Z"></path>
                                  </g>
                                </g>
                              </svg>
                            </p>
                            <small className="hash-text">#43534</small>
                            <p className="__qwText">LR Upload</p>
                          </div>
                        </div>
                      </div>
                        <div
                        className="_quickCards"
                        onClick={() => navigate("/quick_uploads/gan_panelity")}
                      >
                        <div className="_quickCards_body">
                          <div className="text-center">
                            <p className="_fasTruck">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="40px"
                                height="40px"
                                viewBox="0 0 512 512"
                                version="1.1"
                              >
                                <title>details</title>
                                <g
                                  id="Page-1"
                                  stroke="none"
                                  strokeWidth="1"
                                  fill="none"
                                  fillRule="evenodd"
                                >
                                  <g
                                    id="Combined-Shape"
                                    fill="#000000"
                                    transform="translate(64.000000, 64.000000)"
                                  >
                                    <path d="M384,64 L384,384 L64,384 L64,64 L384,64 Z M341.333333,106.666667 L106.666667,106.666667 L106.666667,341.333333 L341.333333,341.333333 L341.333333,106.666667 Z M320,1.42108547e-14 L320,42.6666667 L42.666,42.666 L42.6666667,320 L1.42108547e-14,320 L1.42108547e-14,1.42108547e-14 L320,1.42108547e-14 Z M298.666667,234.666667 L298.666667,277.333333 L149.333333,277.333333 L149.333333,234.666667 L298.666667,234.666667 Z M298.666667,149.333333 L298.666667,192 L149.333333,192 L149.333333,149.333333 L298.666667,149.333333 Z"></path>
                                  </g>
                                </g>
                              </svg>
                            </p>
                            <small className="hash-text">#43534</small>
                            <p className="__qwText">Gain Penalty</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
         
          {/* <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                Accordion 2
              </button>
            </h2>
            <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#quickUploadAccordion">
              <div className="accordion-body">
              <div className="row">
                  <div className='col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-6 '>
                    <div className='_quickCards'>
                      <div className='_quickCards_body'>
                        <div className='text-center'>
                          <p className='_fasTruck'><LiaTruckSolid /></p>
                          <button className='btnView'>Parle Bill</button>
                          <small className='muted-text'>Upload</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-6 '>
                    <div className='_quickCards'>
                      <div className='_quickCards_body'>
                        <div className='text-center'>
                          <p className='_fasTruck'><LiaTruckSolid /></p>
                          <button className='btnView'>Parle Bill</button>
                          <small className='muted-text'>Upload</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-6 '>
                    <div className='_quickCards'>
                      <div className='_quickCards_body'>
                        <div className='text-center'>
                          <p className='_fasTruck'><LiaTruckSolid /></p>
                          <button className='btnView'>Parle Bill</button>
                          <small className='muted-text'>Upload</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-6 '>
                    <div className='_quickCards'>
                      <div className='_quickCards_body'>
                        <div className='text-center'>
                          <p className='_fasTruck'><LiaTruckSolid /></p>
                          <button className='btnView'>Parle Bill</button>
                          <small className='muted-text'>Upload</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-6 '>
                    <div className='_quickCards'>
                      <div className='_quickCards_body'>
                        <div className='text-center'>
                          <p className='_fasTruck'><LiaTruckSolid /></p>
                          <button className='btnView'>Parle Bill</button>
                          <small className='muted-text'>Upload</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-6 '>
                    <div className='_quickCards'>
                      <div className='_quickCards_body'>
                        <div className='text-center'>
                          <p className='_fasTruck'><LiaTruckSolid /></p>
                          <button className='btnView'>Parle Bill</button>
                          <small className='muted-text'>Upload</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                Accordion 3
              </button>
            </h2>
            <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#quickUploadAccordion">
              <div className="accordion-body">
              <div className="row">
                  <div className='col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-6 '>
                    <div className='_quickCards'>
                      <div className='_quickCards_body'>
                        <div className='text-center'>
                          <p className='_fasTruck'><LiaTruckSolid /></p>
                          <button className='btnView'>Parle Bill</button>
                          <small className='muted-text'>Upload</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-6 '>
                    <div className='_quickCards'>
                      <div className='_quickCards_body'>
                        <div className='text-center'>
                          <p className='_fasTruck'><LiaTruckSolid /></p>
                          <button className='btnView'>Parle Bill</button>
                          <small className='muted-text'>Upload</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-6 '>
                    <div className='_quickCards'>
                      <div className='_quickCards_body'>
                        <div className='text-center'>
                          <p className='_fasTruck'><LiaTruckSolid /></p>
                          <button className='btnView'>Parle Bill</button>
                          <small className='muted-text'>Upload</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-6 '>
                    <div className='_quickCards'>
                      <div className='_quickCards_body'>
                        <div className='text-center'>
                          <p className='_fasTruck'><LiaTruckSolid /></p>
                          <button className='btnView'>Parle Bill</button>
                          <small className='muted-text'>Upload</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-6 '>
                    <div className='_quickCards'>
                      <div className='_quickCards_body'>
                        <div className='text-center'>
                          <p className='_fasTruck'><LiaTruckSolid /></p>
                          <button className='btnView'>Parle Bill</button>
                          <small className='muted-text'>Upload</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-6 '>
                    <div className='_quickCards'>
                      <div className='_quickCards_body'>
                        <div className='text-center'>
                          <p className='_fasTruck'><LiaTruckSolid /></p>
                          <button className='btnView'>Parle Bill</button>
                          <small className='muted-text'>Upload</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>

      </div>
      {quickUploadOpen?.open && <QuickUploadModal {...quickProps} />}
    </>
  );
};

export default QuickUpload;
